import BirthdayInput from './birthday-input-controller'

export default BirthdayInput
